export const BASE_PATH = import.meta.env.BASE_URL; // Set by Vite's `base` config

export function stripBasePath(pathname: string): string {
  if (BASE_PATH === '/') return pathname;
  const prefix = BASE_PATH.endsWith('/') ? BASE_PATH.slice(0, -1) : BASE_PATH;
  return pathname.startsWith(prefix) ? pathname.slice(prefix.length) || '/' : pathname;
}

export function withBasePath(path: string): string {
  if (BASE_PATH === '/') return path;
  const prefix = BASE_PATH.endsWith('/') ? BASE_PATH.slice(0, -1) : BASE_PATH;
  return prefix + (path.startsWith('/') ? path : '/' + path);
}
